import { isDevice } from 'expo-device'
import * as StoreReview from 'expo-store-review'

export function showStoreReview() {
  if (isDevice) {
    StoreReview.isAvailableAsync()
      .then(result => {
        if (result === true) {
          StoreReview.requestReview().catch(e => console.log(e))
        } else {
          // not supported, so do nothing
        }
      })
      .catch(e => console.log(e))
  }
}
